import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col, Input, Label, Modal, ModalBody, ModalHeader, FormGroup, Button, ButtonToggle, ModalFooter
} from 'reactstrap';


import FormBuilder from '../../components/forms/modalFormBuilder';
import { required } from '../../components/forms/validation';

import Isvg from 'react-inlinesvg'
import Search from '../../components/search';

import profile from '../../assets/images/profile-pic.png'
import map from '../../assets/svg/map.svg'
import chart from '../../assets/svg/chart.svg'
import edit from '../../assets/svg/edit.svg'
import garabage from '../../assets/svg/garbage.svg'
import arrowDown from '../../assets/svg/arrow-down.svg'
import arrowUp from '../../assets/svg/arrow-up.svg'
import addIcon from '../../assets/svg/add-icon.svg';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import ErrorModal from '../../components/errorModal';

import profileUser from '../../assets/images/user.png';
import notification from '../../assets/svg/notification.svg';
import moreIcon from '../../assets/svg/more.svg';

import { Player, Controls } from '@lottiefiles/react-lottie-player';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

/**
* Page for insert or update landing style
* @author   Aleksandar Dabic
*/
class PaymentManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            loading: true,
            search: ''
        };
    }


    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }



    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.getSynchronizationsList();

        this.initializeSocket();
    }
    componentWillUnmount() {

        if (this.props.socket) {
            this.props.socket.removeListener('paymentManagerSync');
        }
    }

    initializeSocket = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();
            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }
            }, 150);
        }
    }
    registerEvents = async () => {
        this.props.socket.on('paymentManagerSync', (data) => {
            this.getSynchronizationsList();
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }






    stopAnimation = () => {
        this.player.current.play();
    }





    findPayment = () => {
        const caseNumber = this.state.search.trim();
        if (!caseNumber) return;

        this.setState({
            loadingFind: true,
        }, () => {
            fetch(API_ENDPOINT + `/api/payment-manager/find/${caseNumber}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(parseJSON).then(({ result, status }) => {
                let setObj = {
                    loadingFind: false,
                    ...result
                }


                this.setState(setObj)

            })
        })



    }
    syncBillToPayment = (doInsert = false) => {
        const caseNumber = this.state?.paymentData?.caseNumber;
        console.log('Syncing bill to payment for case number:', caseNumber);
        if (!caseNumber) return;

        let data = {
            doInsert
        };

        this.setState({
            loadingSyncBill: true,
        }, () => {
            fetch(API_ENDPOINT + `/api/payment-manager/prepare-for-sync/${caseNumber}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                let setObj = {
                    loadingSyncBill: false,
                    ...result
                }
                if (result?.paymentId) {
                    setObj.syncData = null;
                }

                // console.log('Find payment response:', setObj);
                this.setState(setObj, () => {
                    if (result?.paymentId) {
                        this.findPayment();
                    }
                })

            })
        })


    }
    handleSyncModal = (value) => {
        this.setState({ syncModal: value });
    }
    syncStart = () => {
        this.setState({ syncLoading: true }, () => {
            fetch(API_ENDPOINT + `/api/payment-manager/start/synchronization`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ syncLoading: false, syncModal: false });
                this.getSynchronizationsList(result?._id);
            })
        });
    }
    getSynchronizationsList = (syncId) => {
        fetch(API_ENDPOINT + `/api/payment-manager/synchronizations`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            this.setState({ synchronizationsList: result }, () => {
                if (syncId && result.find(i => i._id == syncId)) {
                    let detailsOpened = this.state.detailsOpened || [];
                    if (!detailsOpened.includes(syncId)) {
                        detailsOpened.push(syncId);
                    }
                    this.setState({ detailsOpened });
                }
            });
        })
    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }

        const { bills, invoices, payments } = this.state.paymentData || { bills: [], invoices: [], payments: [] };
        const synchronizationsList = this.state.synchronizationsList || [];
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide payment-manager-page-wrap" : "dashboard payment-manager-page-wrap"}>
                {
                    this.state.error ?
                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>
                        : null
                }
                <Container fluid>

                    <div className="panel panel-short">
                        <div className="panel-header">
                            <h5 className="component-header">{"Payment Manager".translate(this.props.lang)}</h5>
                        </div>



                        <Row>
                            <Col lg='12' style={{ marginBottom: 20 }}>
                                <div className='payment-manager-find-payment-wrap'>
                                    <FormGroup>
                                        <Label>{'Find Payment'.translate(this.props.lang)}</Label>
                                        <Input type='text' placeholder={'Case number'.translate(this.props.lang)} value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} />
                                    </FormGroup>
                                    <Button color='primary' disabled={this.state.loadingFind} onClick={this.findPayment}>{'Find'.translate(this.props.lang)}</Button>

                                </div>
                            </Col>

                            {
                                this.state.paymentData ?
                                    <>
                                        <Col lg='4'>
                                            <div className='payment-manager-box'>
                                                <h6 style={{ marginBottom: 20 }}>{'Bills'.translate(this.props.lang)}</h6>
                                                {!bills?.length ? <p>{'No bills found for this case number.'.translate(this.props.lang)}</p> : null}
                                                {
                                                    bills.map((item, idx) => {
                                                        return (
                                                            <div key={idx} className='payment-manager-item'>
                                                                <div className='payment-manager-item-value'><span>{'Referral:'}</span> {item?.referral?._id ?? 'referral not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Event:'}</span> {item?.event?._id ?? 'event not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Patient:'}</span> {item?.patientData?._id ? `${item?.patientData?._id} - ${item?.patientData?.userData?.name} (${item?.patientData?.socialSecurityNumber})` : 'patient not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Doctor:'}</span> {item?.referral?.recipientUser ? `${item?.referral?.recipientUser}${item?.referral?.doctorName ? ` - ${item?.referral?.doctorName}` : ''}` : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Case status:'}</span> {item?.referral?.status ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Type:'}</span> {item?.referral?.remissType ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Price:'}</span> {item?.price ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Show bill:'}</span> {item?.showBill ? 'Yes' : 'No'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Bill paid:'}</span> {item?.billPaid ? 'Yes' : 'No'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Created:'}</span> {item?.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Modified:'}</span> {item?.tsModified ? this.props.getStringDateTs(item.tsModified, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>

                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </Col>
                                        <Col lg='4'>
                                            <div className='payment-manager-box'>
                                                <h6 style={{ marginBottom: 20 }}>{'Invoice'.translate(this.props.lang)}</h6>
                                                {!invoices?.length ? <p>{'No invoices found for this case number.'.translate(this.props.lang)}</p> : null}
                                                {
                                                    invoices.map((item, idx) => {
                                                        return (
                                                            <div key={idx} className='payment-manager-item'>
                                                                <div className='payment-manager-item-value'><span>{'Referral:'}</span> {item?.referral?._id ?? 'referral not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Event:'}</span> {item?.event?._id ?? 'event not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Patient:'}</span> {item?.patientData?._id ? `${item?.patientData?._id} - ${item?.patientData?.userData?.name} (${item?.patientData?.socialSecurityNumber})` : 'patient not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Doctor:'}</span> {item?.referral?.recipientUser ? `${item?.referral?.recipientUser}${item?.referral?.doctorName ? ` - ${item?.referral?.doctorName}` : ''}` : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Case status:'}</span> {item?.referral?.status ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Type:'}</span> {item?.referral?.remissType ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Price:'}</span> {item?.price ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Way of payment:'}</span> {item?.wayOfPayment ? item?.wayOfPaymentEn ?? item?.wayOfPayment : 'N/A'}</div>
                                                                {
                                                                    item?.invoiceNumber ?
                                                                        <div className='payment-manager-item-value'><span>{'Reference:'}</span> {item?.invoiceNumber}</div>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    item?.reason ?
                                                                        <div className='payment-manager-item-value'><span>{'Reason:'}</span> {item?.reason}</div>
                                                                        :
                                                                        null
                                                                }
                                                                <div className='payment-manager-item-value'><span>{'Created:'}</span> {item?.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Modified:'}</span> {item?.tsModified ? this.props.getStringDateTs(item.tsModified, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>

                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </Col>
                                        <Col lg='4'>
                                            <div className='payment-manager-box'>
                                                <h6 style={{ marginBottom: 20 }}>{'Payments'.translate(this.props.lang)}</h6>
                                                {!payments?.length ? <p>{'No payments found for this case number.'.translate(this.props.lang)}</p> : null}
                                                {
                                                    payments.map((item, idx) => {
                                                        return (
                                                            <div key={idx} className='payment-manager-item'>
                                                                <div className='payment-manager-item-value'><span>{'Payment:'}</span> {item?._id ? `${item?._id} - ${item?.paymentNumber}` : 'payment not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Referral:'}</span> {item?.caseData?._id ?? 'referral not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Patient:'}</span> {item?.patientData?._id ? `${item?.patientData?._id} - ${item?.patientData?.name} (${item?.patientData?.ssn})` : 'patient not found'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Clinic:'}</span> {item?.clinicInfo?.groupName ? `${item?.clinicInfo?.groupName} - ${item?.clinicInfo?.clinicName} - ${item?.clinicInfo?.clinicSubgroupName}` : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Doctor:'}</span> {item?.caseData?.doctorId ? `${item?.caseData?.doctorId}${item?.caseData?.doctorName ? ` - ${item?.caseData?.doctorName}` : ''}` : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Case status:'}</span> {item?.caseData?.status ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Type:'}</span> {item?.caseData?.type ?? 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Price:'}</span> {item?.amount?.value ? `${item?.amount?.value} ${item?.amount?.currency}` : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Payment status:'}</span> {item?.currentStatus?.status?.key ? item?.currentStatus?.status?.key : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Payment method:'}</span> {item?.currentStatus?.paymentMethod?.key ? item?.currentStatus?.paymentMethod?.key : 'N/A'}</div>
                                                                {
                                                                    item?.currentStatus?.reference ?
                                                                        <div className='payment-manager-item-value'><span>{'Reference:'}</span> {item?.currentStatus?.reference}</div>
                                                                        :
                                                                        null
                                                                }
                                                                <div className='payment-manager-item-value'><span>{'Created:'}</span> {item?.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                <div className='payment-manager-item-value'><span>{'Modified:'}</span> {item?.tsModified ? this.props.getStringDateTs(item.tsModified, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>

                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </Col>
                                        <Col lg='12'>
                                            <div style={{ display: 'flex', flexDirection: 'column', width: 300, gap: 10, marginTop: 10 }}>
                                                {payments?.length ? <>Payments already exists</> : null}
                                                <Button color='primary' disabled={this.state.loadingSyncBill} onClick={() => this.syncBillToPayment()}>{`Insert payment for case ${this.state?.paymentData?.caseNumber}`.translate(this.props.lang)}</Button>
                                            </div>
                                        </Col>
                                    </>
                                    :
                                    null
                            }
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: 50, borderTop: '1px solid #ccc', paddingTop: 30 }}>
                                <Button color='primary' style={{ height: 48 }} disabled={this.state.syncLoading} onClick={() => this.handleSyncModal(true)}>{'Sync payments'.translate(this.props.lang)}</Button>
                            </Col>
                            {
                                synchronizationsList?.length ?
                                    <Col lg="12">
                                        <div className='payment-manager-synchronizations-list-wrap'>
                                            <h6 style={{ marginBottom: 20, marginTop: 20 }}>{'Synchronizations'.translate(this.props.lang)}</h6>
                                            {
                                                synchronizationsList?.map((item, idx) => {
                                                    const isDetailsOpened = (this.state.detailsOpened || []).includes(item._id);

                                                    const tsNow = Math.floor(new Date().getTime() / 1000);
                                                    const pingTs = item.pingTs || 0;
                                                    const isActive = !item.finished && (pingTs + 60 * 20 > tsNow);
                                                    return (
                                                        <div key={idx} className='payment-manager-synchronizations-item'>
                                                            <div className='payment-manager-synchronizations-item-value' onClick={() => {
                                                                let detailsOpened = this.state.detailsOpened || [];
                                                                if (detailsOpened.includes(item._id)) {
                                                                    detailsOpened = detailsOpened.filter(i => i != item._id);
                                                                } else {
                                                                    detailsOpened.push(item._id);
                                                                }
                                                                this.setState({ detailsOpened });
                                                            }}>
                                                                <div><span>{'Started: '}</span> {item?.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                {
                                                                    item?.tsFinished ?
                                                                        <div><span>{'Finished: '}</span> {item?.tsFinished ? this.props.getStringDateTs(item.tsFinished, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                        :
                                                                        item?.pingTs ?
                                                                            <div><span>{'Last activity: '}</span> {item?.pingTs ? this.props.getStringDateTs(item.pingTs, this.props.dateFormat + ' HH:mm') : 'N/A'}</div>
                                                                            :
                                                                            null
                                                                }
                                                                <div><Isvg src={arrowDown} /></div>
                                                            </div>
                                                            {
                                                                isDetailsOpened ?
                                                                    item?.data?.length ?
                                                                        <div className='payment-manager-synchronizations-item-value-details-wrap'>
                                                                            {
                                                                                item?.data?.map((dataItem, dIdx) => {
                                                                                    return (
                                                                                        <div key={`sync-${idx}-data-${dIdx}`} className='payment-manager-synchronizations-item-value-details'>
                                                                                            <div><span>{'Group Id: '}</span> {dataItem?.groupId}</div>
                                                                                            <div><span>{'Group name: '}</span> {dataItem?.groupName}</div>
                                                                                            <div><span>{'Bills count: '}</span> {dataItem?.billsCount}</div>
                                                                                            <div><span>{'Invoices count: '}</span> {dataItem?.invoicesCount}</div>
                                                                                            <div><span>{'Total count: '}</span> {dataItem?.totalCount}</div>
                                                                                            {
                                                                                                dataItem?.syncedCaseNumbers ?
                                                                                                    <div><span style={{ fontWeight: 700 }}>{'Inserted payments: '} {dataItem?.syncedCaseNumbers}</span></div>
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                            {
                                                                                                dataItem?.errors ?
                                                                                                    <div>
                                                                                                        <Button
                                                                                                            color='primary'
                                                                                                            style={{ marginTop: 10 }}
                                                                                                            onClick={() => {
                                                                                                                this.setState({
                                                                                                                    showErrorsForSync: JSON.stringify(dataItem?.errors, null, 4)
                                                                                                                })
                                                                                                            }}>{'Show errors'.translate(this.props.lang)}</Button>

                                                                                                    </div>
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                            {!dataItem?.syncFinished && isActive ?
                                                                                                <div className="loader-wrap" >
                                                                                                    <Player
                                                                                                        autoplay={true}
                                                                                                        loop={true}
                                                                                                        src="/lf30_editor_l5cxzdyf.json"
                                                                                                        style={{ height: "100%", width: "100%", position: 'absolute', top: "50%", left: '50%', transform: 'translate(-50%, -50%)', zIndex: '99999', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
                                                                                                    ></Player>

                                                                                                </div>
                                                                                                :
                                                                                                null}
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <div><span style={{ fontStyle: 'italic', fontSize: 14, padding: 10 }}>{'No data found for this synchronization.'}</span></div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Col>
                                    :
                                    null
                            }

                        </Row>

                    </div>



                </Container >


                {
                    this.state.showErrorsForSync ?
                        <Modal isOpen={this.state.showErrorsForSync} centered >
                            <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ showErrorsForSync: null })}>&times;</button>}>{'Errors'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>
                                <pre>
                                    {this.state.showErrorsForSync}
                                </pre>
                            </ModalBody>
                            <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }}>

                                <Button onClick={() => {
                                    this.setState({
                                        showErrorsForSync: null
                                    })
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.syncData?.preparedData && this.state.syncData?.caseNumber ?
                        <Modal isOpen={this.state.syncData?.preparedData && this.state.syncData?.caseNumber} size='lg' centered >
                            <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ syncData: null })}>&times;</button>}>{'Insert payment'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>
                                <div style={{ maxHeight: "300px", overflow: "auto", background: "#f4f4f4", padding: "10px", borderRadius: "5px" }}>
                                    <pre>
                                        {JSON.stringify(this.state.syncData?.preparedData, null, 4)}
                                    </pre>
                                </div>
                            </ModalBody>
                            <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }}>
                                <Button disabled={this.state.loadingSyncBill} onClick={() => {
                                    this.syncBillToPayment(true);
                                }}>{'Insert payment'.translate(this.props.lang)}</Button>
                                <Button onClick={() => {
                                    this.setState({
                                        syncData: null
                                    })
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.syncModal ?
                        <DeleteModal
                            lang={this.props.lang}
                            isOpen={this.state.syncModal}
                            toggle={() => this.handleSyncModal(false)}
                            handler={() => {
                                this.syncStart();
                            }}
                        >
                            {'Do you want to start synchronization of bills and invoices to payments?'.translate(this.props.lang)}
                        </DeleteModal>
                        :
                        null
                }

            </div >
        );
    }
}

export default Page(PaymentManager);